/** @format */

import { createContext, useContext, useEffect, useState } from "react";
import { dataAtualUTC } from "../utils";
import { useSession } from "./useSession";

const PersonalizacaoContext = createContext();

export function PersonalizacaoProvider({ children }) {
  const { session } = useSession();

  const [personalizacao, setPersonalizacao] = useState({
    isDefaultWeb: true,
    card: {
      destaques: {
        cordestaque: "#DC7209",
        cortextodestaque: "#FFF",
        colorpreco: "#DC7209",
        colortextopercentual: "#FFF",
        bgbotaoativaroferta: "#186DAF",
        colortextbotaoativaroferta: "#FFF",
        bgbotaoofertaativada: "#F9E1AF",
        colortextbotaoofertaativada: "#CE9216",
        colordestaqueseloclube: "#DC7209",
      },
      tabloide: {
        cordestaque: "#DC7209",
        cortextodestaque: "#FFF",
        colorpreco: "#DC7209",
        colortextopercentual: "#FFF",
        bgbotaoativaroferta: "#186DAF",
        colortextbotaoativaroferta: "#FFF",
        bgbotaoofertaativada: "#F9E1AF",
        colortextbotaoofertaativada: "#CE9216",
        colordestaqueseloclube: "#DC7209",
      },
      descontoexclusivo: {
        cordestaque: "#DC7209",
        cortextodestaque: "#FFF",
        colorpreco: "#DC7209",
        colortextopercentual: "#FFF",
        bgbotaoativaroferta: "#186DAF",
        colortextbotaoativaroferta: "#FFF",
        bgbotaoofertaativada: "#F9E1AF",
        colortextbotaoofertaativada: "#CE9216",
        colordestaqueseloclube: "#DC7209",
      },
      cashback: {
        cordestaque: "#DC7209",
        cortextodestaque: "#FFF",
        colorpreco: "#DC7209",
        colortextopercentual: "#FFF",
        bgbotaoativaroferta: "#186DAF",
        colortextbotaoativaroferta: "#FFF",
        bgbotaoofertaativada: "#F9E1AF",
        colortextbotaoofertaativada: "#CE9216",
        colordestaqueseloclube: "#DC7209",
      },
      cordestaque: "#DC7209",
      textodestaque: "Destaque",
      cortextodestaque: "#FFF",
      textoparavoce: "Para você",
      colorpreco: "#DC7209",
      colortextopercentual: "#FFF",
      bgbotaoativaroferta: "#186DAF",
      colortextbotaoativaroferta: "#FFF",
      colordestaqueseloclube: "#DC7209",
      bgbotaoofertaativada: "#F9E1AF",
      colortextbotaoofertaativada: "#CE9216",
      textoCompartilhamento: {
        tabloide:
          "⏰ *Alerta de Oferta:* @nomeoferta de @valorde *por apenas @valorpor.*\nBaixe o app @displayname e receba benefícios exclusivos!\nGoogle: @urlappgoogle\nApple: @urlappapple",
        tabloideSemValorDe:
          "⏰ *Alerta de Oferta:* @nomeoferta *por apenas @valorpor.*\nBaixe o app @displayname e receba benefícios exclusivos!\nGoogle: @urlappgoogle\nApple: @urlappapple",
        cashback:
          "⏰ *Alerta de Cashback 💰:* @nomeoferta por apenas *@valorpor* com *@percentual de cashback.*\nBaixe o app @displayname e receba benefícios exclusivos!\nGoogle: @urlappgoogle\nApple: @urlappapple",
        desconto:
          "⏰ *Alerta de Desconto Exclusivo 🎟️:* @nomeoferta com *@percentual de desconto.*\nNão perca, baixe agora o app @displayname e ative essa oferta \nGoogle: @urlappgoogle\nApple: @urlappapple",
      },
      textValidadeCompradas: true,
      esconderPrecoOferta: false,
      compartilharOferta: true,
    },
    vermais: {
      bgbotaoativartodasofertas: "#186DAF",
      colortextbotaoativartodasofertas: "#FFF",
      botaoativatodasofertasvisible: true,
    },
    guiaofertas: {
      headerbackground: "#FFF",
      headertextcolor: "#70747D",
      tabselectedcolor: "#0D4E7E",
      hasDestaques: false,
      botaoloja: {
        background: "#E2F4FF",
        textcolor: "#163466",
      },
      nometabs: {
        destaques: "Destaques",
        ofertas: "Ofertas",
        cashback: "Dinheiro de volta",
        descontoexclusivo: "Exclusiva do aplicativo",
      },
      colortextvermais: "#0D4E7E",
    },
    headernavigation: {
      colorbotaoleftright: "#0D4E7E",
      colortextfiltro: "#0B0C0D",
    },
    filtros: {
      filtroselecionado: {
        textcolor: "#0D4E7E",
        bgcolor: "#B3E1FF",
      },
      filtronaoselecionado: {
        textcolor: "#555861",
        bgcolor: "#FFF",
      },
    },
  });

  useEffect(() => {
    if (window.location.pathname !== "/autenticacao" && session?.idvarejista) {
      let personalizacao = "";
      let personalizacaoDefault = "default";
      let s3assets;

      const urlSchedular =
        `https://s3.amazonaws.com/gswebhost/zoomboxapp/${session?.idvarejista}/personalizacao/scheduler.json?timestamp=` +
        new Date().getTime();

      fetch(urlSchedular, {
        method: "GET",
      })
        .then(async (response) => {
          if (response.status !== 403) {
            const data = await response.json();

            const dataAtual = dataAtualUTC();
            data.map((item) => {
              const dateStart = new Date(item.dateStart + "T00:00:00.000");
              const dateEnd = new Date(item.dateEnd + "T23:59:59.000");

              const isDefault =
                !item.dateEnd ||
                item.dateEnd === null ||
                item.dateEnd === undefined
                  ? true
                  : false;

              const emUso = dateStart <= dataAtual && dateEnd >= dataAtual;

              if (isDefault && !emUso && dateStart <= dataAtual) {
                personalizacaoDefault = item.identidade;
                return true;
              }

              if (!isDefault && emUso) {
                personalizacao = item.identidade;
                return true;
              }

              return true;
            });

            s3assets = personalizacao || personalizacaoDefault;
          }

          const urlAppJson = `https://gswebhost.s3.amazonaws.com/zoomboxapp/${
            session?.idvarejista
          }/personalizacao/${
            session?.isdev ? s3assets + session?.isdev : s3assets
          }/app.json?timestamp=${new Date().getTime()}`;

          fetch(urlAppJson, {
            method: "GET",
          })
            .then(async (response) => {
              const data = await response.json();
              let url_recomendacao = data.module_recomendacao?.url;
              console.log("url_recomendacao", url_recomendacao, !!url_recomendacao);
              console.log("window.location.href", window.location.href, window.location.hostname !== "localhost");
              console.log("data.module_recomendacao?.redirect_url", data.module_recomendacao?.redirect_url);
              if (url_recomendacao && window.location.hostname !== "localhost" && data.module_recomendacao?.redirect_url) {
                url_recomendacao = url_recomendacao.split("?")[0];
                let current_url = window.location.href;
                const current_url_params = localStorage.getItem("params");

                if (!String(url_recomendacao).includes(current_url)) {
                  console.log(`redirecionando para ${url_recomendacao}${current_url_params}`)
                  window.location.href = `${url_recomendacao}${current_url_params}`;
                }
              }
              setPersonalizacao({ ...data.novotabloide });
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [session]);

  return (
    <PersonalizacaoContext.Provider value={{ personalizacao }}>
      {children}
    </PersonalizacaoContext.Provider>
  );
}

export function usePersonalizacao() {
  const context = useContext(PersonalizacaoContext);

  const { personalizacao } = context;

  return { personalizacao };
}
